<template>
  <div>
    <div class="product-header-actions">
      <div class="row">
        <div class="search-info pull-left">
          {{ lang == "en" ? "Keyword" : "首頁" }} "
          <span class="keyword">{{ params.word }}</span
          >" {{ lang == "en" ? "Total" : "共有" }} {{ product_count }}
          {{ lang == "en" ? "Results" : "個結果" }}
        </div>
        <div class="product-list-info pull-right">
          <div class="form-show-sort text-right">
            <div class="form-group pull-right text-right">
              <label for="p_show">
                {{ lang == "en" ? "Show" : "每頁顯示" }}
              </label>
              <select
                class="form-control input-sm"
                v-model="params.page_num"
                @change="changePageSize"
              >
                <option value="16">16</option>
                <option value="32">32</option>
                <option value="64">64</option>
              </select>
              <label for="p_sort_by">
                {{ lang == "en" ? "Product" : "產品" }}
              </label>
            </div>
            <!-- /.form-group -->
            <div class="view-count pull-right text-right">
              <span class="text-muted"
                >{{ range.from }} {{ lang == "en" ? "to" : "至" }}
                {{ range.to }} / {{ product_count }}
                {{ lang == "en" ? "Products" : "件產品" }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>

    <div class="product-list-container" :class="{ loading: loading }">
      <div class="icon-loading">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only"
          >{{ lang == "en" ? "Loading" : "載入中" }}...</span
        >
      </div>
      <div class="row">
        <div
          is="product-grid"
          :member="member"
          class="col-lg-3 col-md-4 col-sm-4 col-xs-6"
          v-for="product in products"
          :product="product"
          :key="product.product_id"
        ></div>
      </div>
    </div>

    <ul class="pagination">
      <li class="pagination-prev">
        <a href="#" @click.prevent="firstPage()">
          <i class="glyphicon glyphicon-step-backward"></i>
        </a>
      </li>
      <li class="pagination-prev">
        <a href="#" @click.prevent="prevPage()">
          <i class="icon icon-arrow-prev"></i>
        </a>
      </li>
      <li
        v-for="(p, index) in pages"
        :class="{ active: p == params.page }"
        :key="index"
      >
        <a href="#" @click.prevent="loadPage(p)">{{ p }}</a>
      </li>
      <li class="pagination-next">
        <a href="#" @click.prevent="nextPage()">
          <i class="icon icon-arrow-next"></i>
        </a>
      </li>
      <li class="pagination-next">
        <a href="#" @click.prevent="lastPage()">
          <i class="glyphicon glyphicon-step-forward"></i>
        </a>
      </li>
    </ul>
    <!-- ./pagination -->
  </div>
</template>

<script>
export default {
  name: "product-list",
  props: {
    lang: {
      type: String,
    },
    member: {
      type: Object,
    },
  },
  data: function () {
    return {
      page: 1,
      page_size: 16,
      product_count: 0,
      pages: [],
      params: [],
      products: [],
      loading: false,
      range: {
        from: null,
        to: null,
      },
    };
  },
  watch: {
    $route: function (to, from) {
      this.load(to.query);
    },
  },
  methods: {
    reload: function () {
      let url = window.location.pathname + window.location.search;
      url += "#/?" + $.param(this.params);
      history.pushState(null, null, url);
      this.refresh();
    },
    refresh: function () {
      this.$emit("before-refresh");
      this.loading = true;
      this.$http
        .get("/product/data", {
          params: this.params,
        })
        .then(function (resp) {
          this.products = [];
          this.pages = resp.data.page_range;
          this.range = resp.data.range;
          this.product_count = resp.data.product_count;

          this.$nextTick(function () {
            this.products = resp.data.products;
            this.loading = false;
          });
        });
    },
    load: function (params) {
      this.params = params;
      if (!this.params.page_num) this.params.page_num = 16;
      if (!this.params.page) this.params.page = 1;
      //console.log(params);
      this.refresh();
    },
    firstPage: function () {
      this.params.page = 1;
      this.reload();
    },
    loadPage: function (page) {
      this.params.page = page;
      this.reload();
    },
    nextPage: function () {
      if (
        this.params.page >= Math.ceil(this.product_count / this.params.page_num)
      )
        return;
      this.params.page++;
      this.reload();
    },
    prevPage: function () {
      if (this.params.page == 1) return;
      this.params.page--;
      this.reload();
    },
    lastPage: function () {
      this.params.page = Math.ceil(this.product_count / this.params.page_num);
      this.reload();
    },
    changePageSize: function () {
      this.firstPage();
    },
  },
  created: function () {},
};
</script>
